<template>
  <div class="echarts">
    <IEcharts :option="bar" :loading="loading" />
  </div>
</template>

<script>
import IEcharts from "vue-echarts-v3/src/full.js";
export default {
  name: "ExternaRequestTecChart",
  components: {
    IEcharts
  },
  props: {
    DetailParams: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    loading: true,
    bar: {
      title: {
        text: "Gráfico Solicitudes Cerradas"
      },
      tooltip: {},
      xAxis: {
        data: [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "20",
          "21",
          "22",
          "23",
          "24",
          "25",
          "26",
          "27",
          "28",
          "29",
          "30",
          "31"
        ]
      },
      yAxis: {},
      series: [
        {
          name: "Dia : Cantidad de Solicitudes Cerradas",
          type: "line",
          data: []
        }
      ]
    }
  }),
  created() {
    const titulo = this.monthNames(this.DetailParams.Month);
    this.bar.title.text = "Gráfico Solicitudes Cerradas en " + titulo;
  },
  updated() {
    const titulo = this.monthNames(this.DetailParams.Month);
    this.bar.title.text = "Gráfico Solicitudes Cerradas en " + titulo;
  },
  methods: {
    async getChartData() {
      const that = this;
      // await this.$http
      //   .get("/api/serviceRequests/ExternalRequestChartData", {
      //     params: {
      //       company: this.DetailParams.CompanyId,
      //       year: this.DetailParams.Year,
      //       month: this.DetailParams.Month,
      //       technical: this.DetailParams.UserName
      //       // type: this.DetailParams.SRType,
      //       // requestId: 3355
      //     }
      //   })
      // .then(resp => {
      that.bar.series[0].data = Object.values(this.DetailParams.chartData[0]);
      this.loading = false;
      // });
    },
    monthNames(month) {
      switch (month) {
        case 1:
          return "Enero";
        case 2:
          return "Febrero";
        case 3:
          return "Marzo";
        case 4:
          return "Abril";
        case 5:
          return "Mayo";
        case 6:
          return "Junio";
        case 7:
          return "Julio";
        case 8:
          return "Agosto";
        case 9:
          return "Septiembre";
        case 10:
          return "Octubre";
        case 11:
          return "Noviembre";
        case 12:
          return "Diciembre";
      }
      return "";
    }
  }
};
</script>

<style scoped>
.echarts {
  width: 93%;
  height: 400px;
  background-color: #f3f7fa;
  border-radius: 30px;
  margin: 30px;
  padding: 10px;
}
</style>
